var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDay5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000034055503857067786380000013370766803534153130_);}\r\n\t.st2{fill:url(#SVGID_00000160868666564729024040000001345865716927525035_);}\r\n\t.st3{fill:url(#SVGID_00000147901812227912976380000011831695912017540481_);}\r\n\t.st4{fill:url(#SVGID_00000005981538856174782230000013436951223588689557_);}\r\n\t.st5{fill:url(#SVGID_00000045582789887000509790000001909294931059857289_);}\r\n\t.st6{fill:url(#SVGID_00000091000332696140699530000015186715383035393705_);}\r\n\t.st7{fill:url(#SVGID_00000152262441523231853990000003847396354770023341_);}\r\n\t.st8{fill:url(#SVGID_00000027606750785150096770000010022280966695717525_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8882,
    y1: 32,
    x2: 48.229,
    y2: 32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,48.2c-8.9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2c8.9,0,16.2,7.3,16.2,16.2S41,48.2,32.1,48.2z  M32.1,18.8c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2c7.3,0,13.2-5.9,13.2-13.2C45.2,24.7,39.3,18.8,32.1,18.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132063973255715024640000010794902616749943482_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1079,
    y1: 31.3621,
    x2: 63.8335,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000132063973255715024640000010794902616749943482_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009559182448937298030000001625767816096678050_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1665,
    y1: 31.3621,
    x2: 10.8921,
    y2: 31.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 29.9,
    style: {
      fill: "url(#SVGID_00000009559182448937298030000001625767816096678050_)"
    },
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120527494768204102400000006013457908447960471_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 5.5293,
    x2: 33.5005,
    y2: 5.5293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.2,
    style: {
      fill: "url(#SVGID_00000120527494768204102400000006013457908447960471_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065048527768977297890000001211796130262331327_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5005,
    y1: 58.4707,
    x2: 33.5005,
    y2: 58.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 53.1,
    style: {
      fill: "url(#SVGID_00000065048527768977297890000001211796130262331327_)"
    },
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023967321822217645540000015448596613625290628_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 11.752,
    x2: 17.3013,
    y2: 11.752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000023967321822217645540000015448596613625290628_)"
    },
    points: "15.2,16.6 7.6,9 9.7,6.9  17.3,14.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145743223437847197880000008459843260552072101_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 49.187,
    x2: 54.7368,
    y2: 49.187
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145743223437847197880000008459843260552072101_)"
    },
    points: "52.6,54 45,46.5 47.2,44.3  54.7,51.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141419992107675467200000011960608620561645697_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.5952,
    y1: 49.6968,
    x2: 17.3013,
    y2: 49.6968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000141419992107675467200000011960608620561645697_)"
    },
    points: "9.7,54.5 7.6,52.4 15.2,44.8  17.3,47  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114786944558951273320000015064753530525025936_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0308,
    y1: 12.2615,
    x2: 54.7368,
    y2: 12.2615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000114786944558951273320000015064753530525025936_)"
    },
    points: "47.2,17.1 45,15 52.6,7.4  54.7,9.5  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay5);
export default __webpack_public_path__ + "static/media/icon_day5.42dca69212bd9cff6f07422ed11bdb03.svg";
export { ForwardRef as ReactComponent };